/**
 * (c) 2021-2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
export const widthXl = "(min-width: 1200px)";
export const heightMd = "(max-height: 768px)";
